var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",attrs:{"id":"footer"}},[_c('p',{staticClass:"copy"},[_vm._v("Copyright © 2023 - "+_vm._s(new Date().getFullYear())+" 浙江越隆缝制设备有限公司")])])
}
var staticRenderFns = []

export { render, staticRenderFns }